const routes = [
    {
        path: '/cte/cartas-correcoes',
        alias: ['/cte/cartas-correcoes/index'],
        component: () => import('../views/Listar')
    },
    {
        path: '/cte/cartas-correcoes/corrigir',
        component: () => import('../views/Corrigir')
    },
    {
        path: '/cte/cartas-correcoes/visualizar/:id',
        component: () => import('../views/Visualizar')
    },
]

export default routes